<template>
  <div class="quiz choose-pet">

    <!-- Компонент вопрос -->
    <QuizQuestion :question="questionData" />
    <!-- Компонент вопрос -->

    <!-- Компонент ответы -->
    <div
      v-if="!ownershipStatusConfirmed"
      class="quiz-options quiz__single-choice"
    >
      <div
        class="quiz__option quiz__option--with-icon"
        :class="{ selected: ownershipSelection === 'owner_cat' }"
        @click="selectOwnership('owner_cat')"
      >
        <div class="icon--rounded">
          <svg class="icon-cat">
            <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
          </svg>
        </div><span>Да, кошка</span>
        <div class="quiz__option-icon">
          <svg class="icon-correct">
            <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
          </svg>
        </div>
      </div>

      <div
        class="quiz__option quiz__option--with-icon"
        :class="{ selected: ownershipSelection === 'owner_dog' }"
        @click="selectOwnership('owner_dog')"
      >
        <div class="icon--rounded">
          <svg class="icon-dog">
            <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
          </svg>
        </div><span>Да, собака</span>
        <div class="quiz__option-icon">
          <svg class="icon-correct">
            <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
          </svg>
        </div>
      </div>

      <div
        class="quiz__option"
        :class="{ selected: ownershipSelection === 'future_owner' }"
        @click="selectOwnership('future_owner')"
      >
        <span>Нет, но&nbsp;хочу завести</span>
        <div class="quiz__option-icon">
          <svg class="icon-correct">
            <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
          </svg>
        </div>
      </div>

    </div>

    <!-- Второй экран - выбор будущего питомца -->
    <div
      v-if="ownershipStatusConfirmed && showFuturePetQuestion"
      class="quiz-options quiz__single-choice"
    >
      <div
        class="quiz__option quiz__option--with-icon"
        :class="{ selected: futurePetSelection === 'cat' }"
        @click="selectFuturePet('cat')"
      >
        <div class="icon--rounded">
          <svg class="icon-cat">
            <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
          </svg>
        </div>
        <span>Кошка</span>
        <div class="quiz__option-icon">
          <svg class="icon-correct">
            <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
          </svg>
        </div>
      </div>

      <div
        class="quiz__option quiz__option--with-icon"
        :class="{ selected: futurePetSelection === 'dog' }"
        @click="selectFuturePet('dog')"
      >
        <div class="icon--rounded">
          <svg class="icon-dog">
            <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
          </svg>
        </div>
        <span>Собака</span>
        <div class="quiz__option-icon">
          <svg class="icon-correct">
            <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
          </svg>
        </div>
      </div>
    </div>
    <!-- Компонент ответы -->

    <div class="quiz-button">
      <button
        v-if="!ownershipStatusConfirmed"
        @click="handleConfirmOwnership"
        :disabled="!ownershipSelection"
        class="btn"
      >
        Начать игру
      </button>

      <button
        v-if="ownershipStatusConfirmed && showFuturePetQuestion"
        @click="handleStartGameClick"
        :disabled="!futurePetSelection"
        class="btn"
      >
        Начать игру
      </button>
    </div>
  </div>
</template>

<script>
import QuizQuestion from '@/components/QuizQuestion/QuizQuestion.vue'

export default {
  name: 'PetSelectionPage',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: () => ({
        avatar: 'https://s3.twcstorage.ru/96a5fb50-69d073b0-a7b3-42f3-975d-79ba376843fd/mascot/default.png',
        question_text: 'Для начала нужно узнать, есть&nbsp;ли у&nbsp;Вас питомец?',
        image: '/static/img/start/quiz.png'
      })
    },
  },
  data() {
    return {
      ownershipSelection: null, // 'owner_cat', 'owner_dog', 'future_owner'
      ownershipStatusConfirmed: false,
      futurePetSelection: null, // 'cat', 'dog'
    };
  },
  computed: {
    showFuturePetQuestion() {
      return this.ownershipSelection === 'future_owner';
    },

    questionData() {
      const baseQuestion = { ...this.question };

      // Если показываем вопрос о выборе будущего питомца
      if (this.ownershipStatusConfirmed && this.showFuturePetQuestion) {
        baseQuestion.question_text = 'Какого питомца Вы хотели&nbsp;бы завести?';
        baseQuestion.avatar = '/static/img/avatar/default.png';
        baseQuestion.image = '/static/img/start/quiz.png';

        // Меняем аватар и изображение в зависимости от выбора будущего питомца
        if (this.futurePetSelection === 'cat') {
          baseQuestion.avatar = '/static/img/avatar/happy.png';
          baseQuestion.image = '/static/img/start/cat.png';
        } else if (this.futurePetSelection === 'dog') {
          baseQuestion.avatar = '/static/img/avatar/dog.png';
          baseQuestion.image = '/static/img/start/dog.png';
        }

        return baseQuestion;
      }

      // Первый экран - определение статуса владельца
      if (this.ownershipSelection === 'owner_cat') {
        baseQuestion.avatar = '/static/img/avatar/happy.png';
        baseQuestion.image = '/static/img/start/cat.png';
      } else if (this.ownershipSelection === 'owner_dog') {
        baseQuestion.avatar = '/static/img/avatar/dog.png';
        baseQuestion.image = '/static/img/start/dog.png';
      } else {
        baseQuestion.avatar = '/static/img/avatar/default.png';
        baseQuestion.image = '/static/img/start/quiz.png';
      }

      return baseQuestion;
    },

  },
  methods: {
    selectOwnership(status) {
      this.ownershipSelection = status;
    },

    getPetDisplayName() {
      if (this.ownershipSelection === 'owner_cat') {
        return 'Кошка';
      } else if (this.ownershipSelection === 'owner_dog') {
        return 'Собака';
      } else if (this.ownershipSelection === 'future_owner') {
        return 'Хочу завести';
      }
      return 'Не выбрано';
    },

    // Обработчик первой кнопки "Начать игру"
    handleConfirmOwnership() {
      if (!this.ownershipSelection) return;

      this.sendEventYM(
        'step2_click_btn',
        {
          'click_button_step2_param': this.getPetDisplayName()
        }
      );

      this.confirmOwnership();
    },

    // Обработчик второй кнопки "Начать игру" (для будущих владельцев)
    handleStartGameClick() {
      if (!this.futurePetSelection) return;

      this.sendEventYM(
        'step2_click_btn',
        {
          'click_button_step2_param': this.getPetDisplayName()
        }
      );

      this.startGame();
    },

    confirmOwnership() {
      if (!this.ownershipSelection) return;
      this.ownershipStatusConfirmed = true;
      if (this.ownershipSelection !== 'future_owner') {
        this.startGame();
      }
    },

    selectFuturePet(pet) {
      this.futurePetSelection = pet;

    },

    startGame() {
      let courseType = '', initialVariant = 'standard', mindboxTypeClient = undefined, mindboxTypePet = '';

      if (this.ownershipSelection === 'owner_cat') {
        courseType = 'cats'; mindboxTypePet = 'Кошка';
      } else if (this.ownershipSelection === 'owner_dog') {
        courseType = 'dogs'; mindboxTypePet = 'Собака';
      } else if (this.ownershipSelection === 'future_owner') {
        mindboxTypeClient = 'будущий владелец'; initialVariant = 'wants_to_get';
        if (this.futurePetSelection === 'cat') { courseType = 'cats'; mindboxTypePet = 'Кошка'; }
        else if (this.futurePetSelection === 'dog') { courseType = 'dogs'; mindboxTypePet = 'Собака'; }
        else { return; } // Should be disabled
      } else { return; } // Should be disabled

      this.$emit('setupComplete', { courseType, initialVariant, mindboxTypeClient, mindboxTypePet });
    },
  },
};
</script>

<style scoped lang="scss">
.quiz.choose-pet {
  & .quiz__option {
    &.selected {
      border-color: var(--red);

      .quiz__option-icon {
        opacity: 1;

        & svg {
          color: var(--red);
        }
      }

      .icon--rounded {
        background-color: var(--red);
      }
    }
  }
}
</style>
